import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { tags } from '@/mocks/content';

interface TagCloudProps {
  onSearch: (keyword: string) => void;
}

export default function TagCloud({ onSearch }: TagCloudProps) {
  const [activeId, setActiveId] = useState<number | null>(null);

  return (
    <section id="tags" className="py-12 md:py-16 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-4 dv-reveal">
            <SectionHeading
              kicker="热门标签"
              title="热门标签：点一下，直接筛出相关作品"
              desc="这些标签来自作品标题与创作者的常用词。点击任意标签会自动跳到「热门推荐」并完成筛选，想换一个再点就行。"
            />
            <p className="mt-4 text-xs text-foreground-500">
              标签筛选仅作用于本页已有的作品，不会发起任何请求。
            </p>
          </div>

          <div className="lg:col-span-8 dv-reveal">
            <div className="flex flex-wrap gap-2.5">
              {tags.map((tag) => {
                const active = activeId === tag.id;
                return (
                  <a
                    key={tag.id}
                    href="#hot"
                    onClick={() => {
                      setActiveId(tag.id);
                      onSearch(tag.label);
                    }}
                    aria-pressed={active}
                    className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
                      active
                        ? 'border-primary-500 bg-primary-500 text-background-50'
                        : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
                    }`}
                  >
                    <i className="ri-hashtag text-xs opacity-70" />
                    {tag.label}
                    <span
                      className={`rounded-full px-1.5 py-0.5 text-[10px] ${
                        active ? 'bg-background-50/25 text-background-50' : 'bg-background-100 text-foreground-500'
                      }`}
                    >
                      {tag.count}
                    </span>
                  </a>
                );
              })}
            </div>

            {activeId !== null ? (
              <p className="mt-4 inline-flex items-center gap-1.5 text-xs text-primary-700">
                <i className="ri-filter-3-line" />
                已按「{tags.find((tag) => tag.id === activeId)?.label}」筛选，结果见上方热门推荐
              </p>
            ) : (
              <p className="mt-4 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-cursor-line" />
                还没有选择标签
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}